import { useEffect, useState } from 'react';
import { Router as ReactRoute, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { color } from 'constants/styled-theme';
import { ROUTE_PATHS } from 'routes';
import { useLocalStorage, useRoutes } from 'hooks';
import styled from 'styled-components';
import { setTokenData, fetchTabs, getAppData, getRecentlyItems } from 'store/site-actions';
import PropTypes from 'prop-types';

const PageContent = styled.div`
  top: ${props => (props.isTwoRowHeader ? '135px' : '85px')};
  position: relative;
  background-color: ${p => (p.isWhiteBackground ? color('gray0') : color('gray4'))};
  .scrolled {
    position: fixed;
    top: ${props => `${props.height}px`};
    width: 100%;
    z-index: 10;
  }
  @media (max-width: ${p => p.theme.mobile}) {
    background-color: ${color('gray0')};
    top: 64px;
    width: 100%;
    .scrolled {
      top: 64px;
      width: 100%;
      z-index: 99998;
      background-color: ${color('gray0')};
    }
  }
`;

export const Route = ({ isPrivate, children, path, isWhiteBackground, ...rest }) => {
  const [height, setHeight] = useState(null);
  const { getStorage, removeStorage } = useLocalStorage();
  const history = useHistory();
  const { isFaqTab, isAdminTab, isMyAccountTab } = useRoutes();
  const dispatch = useDispatch();
  const { tokenData, isUnauthorized } = useSelector(state => state.site);
  const storageToken = getStorage('token');
  const recentlyViewItems = getStorage('recentlyView');
  const token = tokenData || storageToken;

  useEffect(() => {
    if (isUnauthorized) {
      dispatch(setTokenData(null));
      return removeStorage('token');
    }
    if (isPrivate) {
      if (!token || !token.expiresIn) {
        return history.push(ROUTE_PATHS.LOGIN);
      }
    }
    if (!tokenData && !isUnauthorized && storageToken) dispatch(setTokenData(token));
  }, [path]);
  useEffect(() => {
    dispatch(fetchTabs());
    dispatch(getAppData());
  }, []);

  useEffect(() => {
    return history.listen(location => {
      setTimeout(() => {
        if (location.pathname === ROUTE_PATHS.ACTIVE_AUCTIONS) return;
        if (/Edge/.test(navigator.userAgent)) {
          window.scrollTop(0);
        } else {
          window.scrollTo(0, 0);
        }
      });
    });
  }, [history]);

  useEffect(() => {
    setHeight(document.getElementById('headerBar').clientHeight);
    if (!!recentlyViewItems) {
      dispatch(
        getRecentlyItems({ listingIds: recentlyViewItems, pageSize: recentlyViewItems.length })
      );
    }
  }, [path]);

  return (
    <PageContent
      height={height}
      isTwoRowHeader={isAdminTab || isMyAccountTab || isFaqTab}
      isWhiteBackground={isWhiteBackground}
    >
      <ReactRoute {...{ history, children, path, height, ...rest }} />
    </PageContent>
  );
};

Route.propTypes = {
  isPrivate: PropTypes.bool,
  props: PropTypes.object,
  children: PropTypes.node,
  path: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  isWhiteBackground: PropTypes.bool
};
